import axios from "axios";

export default {
    getBusinesses: function (params) {
        return axios.get("https://www.pelicananalytics.co/pages/" + params);
    },
    getPosts: function (businessID, token) {
        return axios.post("https://www.pelicananalytics.co/saveSnapAccount", {
            pageId: businessID,
            token: token
        });
    }
};

